import { Lightning } from '@lightningjs/sdk';
import SlideShow from '../../../../templates/blocks/slideShow/slideShow.component';
import { HEIGHT } from '../../../hero.style';
import { getInitialStyle } from './hero.skeleton.style';

export class HeroSkeleton extends Lightning.Component {
  static _template() {
    return getInitialStyle();
  }

  static getHeight(data) {
    const { bottom } = SlideShow.getOffsetsByBlockData(data);

    return HEIGHT[data.screenSize] + bottom;
  }
}
